module.exports = __webpack_public_path__ + "img/page-heading-pattern.8fc8b6e1.png";